module.exports = __webpack_public_path__ + "weathericons-regular-webfont.4618f0de2a818e7ad3fe.ttf";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module id = ../../../../../src/scss/icons/weather-icons/fonts/weathericons-regular-webfont.ttf
// module chunks = styles